import { useQuery } from 'react-query';

import { appConfigsApi } from 'api';

export const useGatewayAppConfigs = () =>
  useQuery(['gateway-app-configs'], appConfigsApi.getGatewayConfigs, {
    staleTime: Infinity,
  });
